import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./Services.css";
import FinancialPlanning from "./services/FinancialPlanning";
import MutualFunds from "./services/MutualFunds";
import EstatePlanning from "./services/EstatePlanning";
import TaxPlanning from "./services/TaxPlanning";
import ServicesHome from "./services/ServicesHome";
import Sidebar from "../components/Sidebar";

const Services = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <div className="services-page">
      {/* Sidebar */}
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />

      {/* Main Content */}
      <main className={`services-content ${isSidebarOpen ? "open" : "closed"}`}>
        <Routes>
          <Route path="/" element={<ServicesHome />} />
          <Route
            path="future-freedom-planning"
            element={<FinancialPlanning />}
          />
          <Route path="mutual-funds" element={<MutualFunds />} />
          {/* <Route path="life-insurance" element={<LifeInsurance />} /> */}
          {/* <Route path="general-insurance" element={<GeneralInsurance />} /> */}
          <Route path="estate-guidance" element={<EstatePlanning />} />
          <Route path="tax-guidance" element={<TaxPlanning />} />
          {/* <Route path="education-guidance" element={<EducationPlanning />} /> */}
          {/* <Route path="retirement-superannuation" element={<RetirementSuperannuation />} /> */}
          {/* <Route path="research-development" element={<ResearchDevelopment />} /> */}
          {/* <Route path="child-marriage-guidance" element={<ChildMarriagePlanning />} /> */}
        </Routes>
      </main>
    </div>
  );
};

export default Services;
